import React, { createContext, useContext } from 'react';
import brandConfig from '../brand-config.json';

/**
 * BrandContext provides brand configuration throughout the app.
 *
 * The brand-config.json file is the source of truth for branding.
 * For white-label deployments, the build script swaps this file
 * with the appropriate brand's configuration before building.
 *
 * Usage:
 *   const { name, colors, tagline } = useBrand();
 */

const BrandContext = createContext(brandConfig);

export const BrandProvider = ({ children }) => {
  return (
    <BrandContext.Provider value={brandConfig}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrand must be used within a BrandProvider');
  }
  return context;
};

export default BrandContext;
